import React from 'react';
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom';
import Login from './login';
import LoginWithOutlook from './LoginWithOutlook';
import Home from './home';
import Fileupload from './fileupload/fileupload';
import ImageCompare from './fileupload/imagecompare';
import App from './fileupload/ExcelUpload';
import TabTrail from './fileupload/TabTrail'
import { createBrowserHistory } from "history";
import Cookies from "js-cookie";

import { SessionContext, getSessionCookie, setSessionCookie } from "./session.ts";

import MastersLyout from "./components/masters/MastersLayout";
import { auth } from './firebase/firebaseconfig';

const history = createBrowserHistory();

// function Router() {
class Router extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loginSuccess: true,
            session: null
        }
        this.LoginInValue = this.LoginInValue.bind(this)
    }

    componentDidMount() {
        var page = this;

        page.setState({ session: getSessionCookie() },
        () => {
            if (page.state.session == null) {
                if(history.location.pathname != "/"){
                    window.location.href = "/";
                }
              }
        });
    }

    LoginInValue(selectedValue) {
        this.setState({
            loginSuccess: selectedValue
        })
        this.props.history.push('/analysis')
    }

    sessionLogout(){
        var page = this;
        auth.signOut();
        Cookies.remove("session");
        page.setState({loginSuccess: false});
        window.location.href = "/";
    }

    render() {
        var page = this;
        return (
            <SessionContext.Provider value={page.state.session}>
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/">
                            <Login props={this.state} loginSuccess={this.state.loginSuccess} LoginInValue={this.LoginInValue} />
                            {/* <LoginWithOutlook/> */}
                        </Route>
                        <Route path="/analysis">
                            {this.state.loginSuccess == true ?
                                <Fileupload loginSuccess={this.state.loginSuccess} />
                                :
                                <Login loginSuccess={this.state.loginSuccess} LoginInValue={this.LoginInValue} />
                            }
                        </Route>
                        <Route exact path="/TabTrail">
                            <TabTrail loginSuccess={this.state.loginSuccess} />
                        </Route>
                        {/* <Route exact path="/compare">
                <ImageCompare />
            </Route>*/}
                        <Route exact path="/home">
                            {
                                page.state.session == null ? "" :
                                <Home loginSuccess={this.state.loginSuccess} sessionLogout={() => this.sessionLogout()} />
                            }
                        </Route>
                        <Route path="/masters">
                            {
                                page.state.session == null ? "" :
                                <MastersLyout loginSuccess={this.state.loginSuccess} sessionLogout={() => this.sessionLogout()} />
                            }
                        </Route>
                        <Route path="*">
                            Not Found
                        </Route>
                    </Switch>
                </BrowserRouter>
            </SessionContext.Provider>
        )
    }
}

export default Router;